import { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  IconButton,
} from "@mui/material";
import {
  Description,
  Visibility,
  Warning,
  CheckCircle,
} from "@mui/icons-material";
import { Vocabulary } from "../../Utils/Vocabulary";
import styles from "../../Styles/clientAccount.module.css";
import moment from "moment";
import { ClientDocumentTypes } from "../../Utils/Constants";
import { DocumentData } from "../../Utils/Types";
import DocumentViewer from "../Widgets/DocumentViewer";

interface DocumentsSectionProps {
  documents: DocumentData[];
}

export default function DocumentsSection({ documents }: DocumentsSectionProps) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState<string | null>(null);
  const [selectedDocTitle, setSelectedDocTitle] = useState<string>("");

  const handlePreviewDocument = (docUrl: string, docTitle: string) => {
    setSelectedDocUrl(docUrl);
    setSelectedDocTitle(docTitle);
    setPreviewOpen(true);
  };
  const isDocumentExpired = (expiryDate: string) => {
    return moment().isAfter(moment(expiryDate));
  };

  const getDocumentStatusText = (expiryDate: string) => {
    const isExpired = isDocumentExpired(expiryDate);
    return isExpired
      ? Vocabulary.expired + ` ${moment(expiryDate).format("DD.MM.YYYY")}`
      : `${Vocabulary.validUntil} ${moment(expiryDate).format("DD.MM.YYYY")}`;
  };
  
  return (
    <Card
      className={styles.infoCard}
      elevation={2}
      style={{ marginBottom: "24px" }}
    >
      <CardContent>
        <Typography variant="h5" className={styles.sectionTitle}>
          <Description className={styles.sectionIcon} />
          {Vocabulary.documentInformation}
        </Typography>

        <Grid container spacing={2} style={{ marginTop: "8px" }}>
          {documents?.length != 0 &&
            Object.values(documents)?.map((document, key) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={String(document?.documentId || key)}
              >
                <Card className={styles.documentCard} variant="outlined">
                  <CardContent className={styles.documentContent}>
                    <Box className={styles.documentHeader}>
                      <Typography
                        variant="body1"
                        className={styles.documentName}
                      >
                        {
                          ClientDocumentTypes[
                            Object.keys(documents)[
                              key
                            ] as keyof typeof ClientDocumentTypes
                          ]
                        }
                      </Typography>
                      <IconButton
                        onClick={() => handlePreviewDocument(document.documentId.document, ClientDocumentTypes[Object.keys(documents)[key] as keyof typeof ClientDocumentTypes])}
                        className={styles.previewButton}
                        size="small"
                      >
                        <Visibility />
                      </IconButton>
                    </Box>
                    <Box className={styles.documentStatus}>
                      {isDocumentExpired(document.documentId.expirationDate) ? (
                        <Warning className={styles.expiredIcon} />
                      ) : (
                        <CheckCircle className={styles.validIcon} />
                      )}
                      <Typography
                        variant="body2"
                        className={
                          isDocumentExpired(document.documentId.expirationDate)
                            ? styles.expiredText
                            : styles.validText
                        }
                      >
                        {getDocumentStatusText(
                          document.documentId.expirationDate
                        )}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          {documents.length === 0 && (
            <Grid item xs={12}>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  padding: "16px",
                  color: "#2e3a59",
                }}
              >
                Nu sunt documente disponibile.
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>

      <DocumentViewer
        urls={selectedDocUrl ? [selectedDocUrl] : undefined}
        open={previewOpen}
        onClose={setPreviewOpen}
        title={selectedDocTitle}
        htmlContent=""
      />
    </Card>
  );
}
